import { render, staticRenderFns } from "./couponRecord.vue?vue&type=template&id=5bcabb20&scoped=true&"
import script from "./couponRecord.vue?vue&type=script&lang=js&"
export * from "./couponRecord.vue?vue&type=script&lang=js&"
import style0 from "./couponRecord.vue?vue&type=style&index=0&id=5bcabb20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcabb20",
  null
  
)

export default component.exports